import React, { PureComponent } from 'react';

class NotFound extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            loginData: null
        };
    }

    render() {
        return (
            <div id="notFoundPage">
                404 Page Not Found! 
            </div>
        );
    }
}

export default NotFound;
